// extracted by mini-css-extract-plugin
module.exports = {"AdSlotSticky":"pg_a pz_bi pz_mm","AdSlotSticky__slot":"pg_b pz_cw","AdSlotSticky__slot--left":"pg_c pz_qp","AdSlotSticky__slot--right":"pg_e pz_qq"};